import { Modal, Row, Col } from "react-bootstrap";
import LogsViewer from "../logs/LogsViewer";
import "./modal.css";

const LogsModal = ({
  showLogsModal,
  handleLogsClose,
  podInfo,
  selectedContainer,
}) => {
  const container = podInfo.containers[selectedContainer];

  const handleCopyLogs = () => {
    const logs = container?.logs || "";
    navigator.clipboard
      .writeText(logs)
      .then(() => {
        // Optional: Add a toast or notification to show success
        console.log("Logs copied to clipboard");
      })
      .catch((err) => {
        console.error("Failed to copy logs:", err);
      });
  };

  return (
    <Modal
      show={showLogsModal}
      onHide={handleLogsClose}
      size="lg"
      centered
      dialogClassName="logs-modal"
    >
      <Modal.Header>
        <Row className="logs-title align-items-center w-100">
          <Col md={3}>
            <h4 className="m-0">Logs</h4>
          </Col>
          <Col md={6} className="text-center">
            <p className="m-0">Container: {container.name}</p>
          </Col>
          <Col
            md={3}
            className="d-flex justify-content-between align-items-center"
          >
            <div>
              <i
                className="fas fa-copy me-3"
                style={{ cursor: "pointer" }}
                onClick={handleCopyLogs}
                title="Copy logs to clipboard"
              ></i>
              <i
                className="fas fa-sync"
                style={{ cursor: "pointer" }}
                title="Refresh logs"
              ></i>
            </div>
            <i
              className="fas fa-times"
              style={{ cursor: "pointer" }}
              onClick={handleLogsClose}
              title="Close"
            ></i>
          </Col>
        </Row>
      </Modal.Header>
      <Modal.Body className="p-0">
        <LogsViewer
          logs={podInfo.containers[selectedContainer]?.logs}
          containerIndex={`modal-${selectedContainer}`}
          scrollableTargetId={`modal-logs-${selectedContainer}`}
          isModal={true}
        />
      </Modal.Body>
    </Modal>
  );
};

export default LogsModal;
